import axios from 'axios';
import { api } from '../../../../../global/js/funciones';
import { MODULOS_FASES_BIENESTAR } from '../../../helper';

const API_URL_FICHA = `${api}/api/v1.0/bienestar/generar_pdf`;
const API_URL_FASE = `${api}/api/v1.0/bienestar/generar_pdf_fase`;

const NOMBRE_CAMPO = (campo) => campo
    .replace(/_/g, ' ')
    .replace(/^./, (c) => c.toUpperCase());

// DRF responde los errores de validacion como {campo: ["mensaje"]}
const mensajeDeRespuesta = (data) => {
    if (!data) return null;
    if (typeof data === 'string') return data;
    if (data.detail) return data.detail;
    if (data.error) return data.error;

    const partes = Object.keys(data).map((campo) => {
        const valor = data[campo];
        const texto = Array.isArray(valor) ? valor.join(' ') : String(valor);
        if (!texto) return null;
        return campo === 'non_field_errors' ? texto : `${NOMBRE_CAMPO(campo)}: ${texto}`;
    }).filter(Boolean);

    if (partes.length === 0) return null;
    if (partes.length <= 3) return partes.join(' | ');
    return `${partes.slice(0, 3).join(' | ')} (y ${partes.length - 3} más)`;
};

export const enviarAlBackendPdf = async (datosFormulario, firmas, bienestarId, flujo = 'FICHA') => {
    try {
        const token = localStorage.getItem('token');
        
        if (!token) {
            throw new Error('No hay token de autenticación. Por favor, relóguese.');
        }

        const payload = {
            ...datosFormulario,
            fecha_generacion: datosFormulario?.fecha_generacion || new Date().toISOString(),
            ...firmas,
            bienestar_id: bienestarId,
            modulos_fases_bienestar: MODULOS_FASES_BIENESTAR,
        };

        const endpoint = flujo === 'FASE' ? API_URL_FASE : API_URL_FICHA;

        const response = await axios.post(endpoint, payload, {
            headers: {
                'Authorization': `JWT ${token}`,
                'Content-Type': 'application/json',
            },
            timeout: 20000,
        });

        return response.data;

    } catch (error) {
        if (error.response) {
            throw new Error(
                mensajeDeRespuesta(error.response.data)
                || `Error del servidor al generar PDF (código ${error.response.status})`
            );
        } else if (error.code === 'ECONNABORTED') {
            throw new Error('Tiempo de espera agotado al generar el PDF. Intente nuevamente.');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor. Verifique la conexión.');
        } else {
            throw new Error(error.message || 'Error desconocido');
        }
    }
};
